var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_inbox_24px",
    d: "M15.444,3H4.548a1.537,1.537,0,0,0-1.54,1.556L3,15.444A1.549,1.549,0,0,0,4.548,17h10.9A1.56,1.56,0,0,0,17,15.444V4.556A1.555,1.555,0,0,0,15.444,3Zm0,9.333H12.333a2.333,2.333,0,1,1-4.667,0H4.548V4.556h10.9Z",
    transform: "translate(-3 -3)",
    fill: "#455079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.3668a6f8639362ff4b2b6457383c4f58.svg";
export { ForwardRef as ReactComponent };